// extracted by mini-css-extract-plugin
export default {"label":"account_label__Wz5LV","phone":"account_phone__jT6lE","phoneInput":"account_phoneInput__1iRO4"};